import React, { useState, useEffect, useContext } from "react";
import { Context } from "../LocalWrapper";
import "./RequiredDocs.css";
import {
  CardTravel,
  Group,
  LocalShipping,
  Business,
  //   DocumentScannerIcon,
} from "@mui/icons-material";
import DocumentScannerIcon from "@mui/icons-material/DocumentScanner";
import { t } from "i18next";

const RequiredDocs = () => {
  const context = useContext(Context);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);

  useEffect(() => {
    const fetchedCategories = t("cont_docs.categories", {
      returnObjects: true,
    });

    if (Array.isArray(fetchedCategories)) {
      setCategories(fetchedCategories);
      setSelectedCategory(fetchedCategories[0]);
    } else {
      console.error("Fetched categories are not an array:", fetchedCategories);
    }
  }, []);

  const iconMap = {
    new_contract_broker: <CardTravel className="side-icon" />,
    new_contract_personal: <Group className="side-icon" />,
    new_contract_company: <Business className="side-icon" />,
    individual_contracts: <Group className="side-icon" />,
    company_contracts: <Business className="side-icon" />,
    ownership_transfer_individuals: <LocalShipping className="side-icon" />,
    ownership_transfer_companies: <Business className="side-icon" />,
    tourism_contracts: <CardTravel className="side-icon" />,
    petroleum_contractor_contracts: <LocalShipping className="side-icon" />,
  };

  return (
    <div className="category-page" dir={context.dir}>
      <div className="sidebar">
        <h2 className="oz-subtitle">{t("cont_docs.categories_title")}</h2>
        <ul>
          {categories?.map((category) => (
            <li
              key={category.type}
              onClick={() => setSelectedCategory(category)}
              className={`${
                selectedCategory?.type === category.type ? "active" : ""
              } oz-paragraph`}
            >
              {iconMap[category.icon_img_src]}
              {/* Render the appropriate MUI icon */}
              {category.type}
            </li>
          ))}
        </ul>
      </div>
      <div className="details">
        <h1 className="oz-title">{t("cont_docs.title")}</h1>
        {selectedCategory && (
          <div className="details-box">
            <h2 className="oz-subtitle">{selectedCategory.type}</h2>
            <ul>
              {selectedCategory.requirements.map((req, index) => (
                <li key={index}>
                  <DocumentScannerIcon className="details-list-icon" />
                  <p className="details-list-text oz-paragraph">{req}</p>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};

export default RequiredDocs;
